module.exports = __webpack_public_path__ + "img/colorblind.91c51107.svg";